import { integer, snakeCase, text, varchar } from 'drizzle-orm/pg-core'
import { id, timestamps } from '../utils/columns.helpers'
import { categoryStatusEnum } from './_common.table'

export const heroSlidesTable = snakeCase.table('hero_slides', {
    id: id('hs'),
    title: varchar({ length: 255 }).notNull(),
    subtitle: text(),
    imageUrl: text().notNull(),
    linkUrl: text(),
    status: categoryStatusEnum().notNull().default('active'),
    sortOrder: integer().notNull().default(0),
    ...timestamps,
})
